
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Interaction/Refresher.html",
      function () {
        return require("private-next-pages/Interaction/Refresher.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Interaction/Refresher.html"])
      });
    }
  